import styled, { css } from 'styled-components';

import { styles } from '../../styles';

const optionCss = css`
  ${styles.py.sm};
  ${styles.px.md};
  :hover {
    ${styles.bg.primary};
    ${styles.color.textOnPrimary};
  }
`;

export const OptionContainer = styled.div<{
  isActive?: boolean;
  isPlaceholder?: boolean;
}>`
  width: 100%;
  ${(p) => (!p.isPlaceholder ? optionCss : null)};
  ${(props) => (props.isActive ? styles.bg.primaryLight : null)};
`;

export const defaultRenderOption = (
  option: any,
  { active, placeholder }: { active?: boolean; placeholder?: boolean }
) => {
  const o = option as { text?: string; label?: string; value?: string };
  return (
    <OptionContainer
      isActive={active && !placeholder}
      isPlaceholder={placeholder}
    >
      {o.text || o.label || o.value}
    </OptionContainer>
  );
};
export const defaultExtractKey = (option: any, idx: number) => {
  if (typeof option === 'string' || typeof option === 'number') {
    return idx;
  }
  return option.key || option.value;
};

export const DefaultDeselect = styled.div`
  transition: 0.3s;
  :hover {
    ${styles.color.primary}
  }
`;

export const defaultSearchKeys = ['label', 'value', 'key'];
